import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import qs from 'query-string';

export const getRtkConfig = (url: string) =>
  fetchBaseQuery({
    baseUrl: url,
    credentials: 'include',
    prepareHeaders: (headers, api) => {
      const token = localStorage.getItem('token');
      // If we have a token set in localStorage, let's assume that we should be passing it.
      if (token) {
        headers.set('Authorization', `Token ${token}`);
      }
      return headers;
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'comma' }),
  });
